export default __webpack_public_path__ + "static/media/email.c0d3919e.png";